// modules
import { handleActions } from 'redux-actions'

// actions
import {
  setCaregiverGamificationVault,
  setCaregiverGamificationHistory,
  resetCaregiverGamification
} from 'src/store/modules/caregiver/gamification'

const initialState = {
  vault: {},
  history: []
}

export default handleActions(
  {
    [setCaregiverGamificationVault](state, { payload: vault }) {
      return {
        ...state,
        vault
      }
    },

    [setCaregiverGamificationHistory](state, { payload: history }) {
      return {
        ...state,
        history
      }
    },

    [resetCaregiverGamification]() {
      return initialState
    }
  },
  initialState
)
